import '../../styles/components/read-more.scss';

class ReadMore extends HTMLElement {
  constructor() {
    super();

    this.readMoreBtn = this.querySelector('[data-read-more]');
    this.readLessBtn = this.querySelector('[data-read-less]');
    this.readBtns = this.querySelectorAll('[data-read]');
    this.content = this.querySelector('[data-content]');
    this.maxLines = parseInt(this.getAttribute('data-max-lines'));

    if (this.maxLines > 0 && this.shouldShowReadMore()) {
      this.querySelector('.read-more__read-btns').classList.remove('hide');
    }

    this.readBtns.forEach((btn) => {
      btn.addEventListener('click', this.readMore.bind(this));
    });
  }


  shouldShowReadMore() {
    const lineHeight = parseFloat(window.getComputedStyle(this.content).lineHeight);
    const maxHeight = lineHeight * this.maxLines;
    return this.content.scrollHeight > maxHeight;
  }

  readMore() {
    this.content.classList.toggle('is-truncated');

    if (this.readLessBtn?.classList.contains('hide')) {
      this.readLessBtn.classList.remove('hide');
      this.readMoreBtn.classList.add('hide');
    } else {
      this.readMoreBtn.classList.remove('hide');
      this.readLessBtn.classList.add('hide');
    }
  }
}

try {
  customElements.define('read-more', ReadMore);
} catch (e) {}
